import LetterElementModel from 'letter/model/letter_element_model'

export default function fabricObjectToTextLetterElement(fabricObject, letterElement) {
  let fontColor
  if (fabricObject.fill === 'rgb(0,0,0)') {
    fontColor = '#000000'
  } else {
    fontColor = fabricObject.fill
  }

  const options = {
    type: 'text',
    sortId: fabricObject._sortId,
    x: fabricObject.left,
    y: fabricObject.top,

    metaData: {
      html: fabricObject.text,
      font: fabricObject.fontFamily,
      color: fontColor,
      fontSize: fabricObject.fontSize,
      fontWeight: fabricObject.fontWeight,
      bold: fabricObject.fontWeight === 700,
      italic: fabricObject.fontStyle === 'italic',
      underline: fabricObject.underline,
    },
  }

  if (letterElement) {
    letterElement.set(options)
    return letterElement
  } else {
    return new LetterElementModel(options)
  }
}
